const ENGAGE_BASE = '/dashboard/engage';
const REPUTATION_BASE = '/dashboard/reputation';
const VOICE_BASE = '/dashboard/voice';
const AI_TOOLS_BASE = '/dashboard/ai-tools';
const AI_CREDENTIALS_BASE = `${AI_TOOLS_BASE}/credentials`;
const AI_SKILLS_BASE = `${AI_TOOLS_BASE}/skills`;

/**
 * Relative paths for the automations and segments routes, which Engage and Reputation both
 * mount under their own base. Resolve them through the feature surface rather than assuming a base.
 */
export const featureNestedRoutes = {
  AUTOMATIONS_EDIT: 'automations/edit/:automation-id',
  SEGMENTS_NEW: 'segments/new',
  SEGMENTS_EDIT: 'segments/edit/:canonicalVersionId',
} as const;

export const appRoutes = {
  ENGAGE_SETUP: ENGAGE_BASE,
  ENGAGE_TENANTS: `${ENGAGE_BASE}/tenants`,
  ENGAGE_AUTOMATIONS: `${ENGAGE_BASE}/automations`,
  ENGAGE_SEGMENTS: `${ENGAGE_BASE}/segments`,
  ENGAGE_SEGMENTS_NEW: `${ENGAGE_BASE}/${featureNestedRoutes.SEGMENTS_NEW}`,
  REPUTATION_SETUP: REPUTATION_BASE,
  REPUTATION_AUTOMATIONS: `${REPUTATION_BASE}/automations`,
  REPUTATION_SEGMENTS: `${REPUTATION_BASE}/segments`,
  REPUTATION_SEGMENTS_NEW: `${REPUTATION_BASE}/${featureNestedRoutes.SEGMENTS_NEW}`,
  VOICE: VOICE_BASE,
  AI_AGENTS: AI_TOOLS_BASE,
  AI_TOOLS: `${AI_TOOLS_BASE}/tools`,
  AI_TOOL_NEW: `${AI_TOOLS_BASE}/new`,
  AI_TOOL_EDIT: `${AI_TOOLS_BASE}/:id`,
  AI_CREDENTIALS: AI_CREDENTIALS_BASE,
  AI_SKILLS: AI_SKILLS_BASE,
} as const;

export const buildAiToolEditPath = (id: string): string => appRoutes.AI_TOOL_EDIT.replace(':id', id);

/** Build navigation path by replacing :automation-id param, under the given feature base. */
export const buildAutomationEditPath = (basePath: string, automationId: string): string =>
  `${basePath}/${featureNestedRoutes.AUTOMATIONS_EDIT}`.replace(':automation-id', automationId);

/** Build navigation path by replacing :canonicalVersionId param, under the given feature base. */
export const buildSegmentEditPath = (basePath: string, canonicalVersionId: string): string =>
  `${basePath}/${featureNestedRoutes.SEGMENTS_EDIT}`.replace(':canonicalVersionId', canonicalVersionId);
